import { ref } from 'vue'

export function useMasterDialog() {
    const masterData = ref({})

    /**
     * Initializes the data for the dialog based on the current mode (create, update, or duplicate).
     * @param {Object} options - The initialization options.
     * @param {Object} options.initialData - The initial data to use for updating or duplicating.
     * @param {Object} options.defaultData - The default data structure to use when creating a new item.
     * @param {boolean} options.isAdd - A flag indicating if the dialog is in 'add' mode.
     * @param {string[]} [options.ignoreDuplicateFields=['id']] - An array of field names to remove when duplicating an item. Defaults to ['id'].
     */
    const initializeData = ({ initialData, defaultData, isAdd, ignoreDuplicateFields = ['id'] }) => {
        // A check to prevent errors if initialData is null or undefined
        const hasInitialData = initialData && Object.keys(initialData).length > 0;

        if (isAdd && hasInitialData) {
            // Duplicate mode: Deep clone the initial data and remove specified fields.
            const clone = JSON.parse(JSON.stringify(initialData));
            ignoreDuplicateFields.forEach(field => {
                delete clone[field];
            });
            masterData.value = clone;
        } else if (isAdd) {
            // Add new mode: Use a deep copy of the default data.
            masterData.value = JSON.parse(JSON.stringify(defaultData));
        } else {
            // Update mode: Use a deep copy of the initial data.
            masterData.value = JSON.parse(JSON.stringify(initialData));
        }
    };

    return {
        masterData,
        initializeData
    }
}